import * as React from "react";
import { PropTypes } from "components/controls";
import Alert from "common/components/controls/Alert";
import HU from "common/utils/HostovaniDlouhodobaUtils";

export interface StavProps {
    stav: number;
    dat_potvrz_ic?: Date;
    dat_potvrz_kc?: Date;
    zamitnuto_ic: boolean;
    zamitnuto_kc: boolean;
}


class Stav extends React.PureComponent<StavProps>{

    render() {

        const { stav, dat_potvrz_ic, dat_potvrz_kc, zamitnuto_ic, zamitnuto_kc } = this.props;
        let content: string;
        let color: PropTypes.Color = 'warning';
        let str: string;
        switch (stav) {
            case HU.Stav_PotvrzeniICaDomKC:
                str = 'individuelní člen a domácí kolektivní člen';
                if (dat_potvrz_ic && !dat_potvrz_kc) {
                    str = 'domácí kolektivní člen';
                } else if (!dat_potvrz_ic && dat_potvrz_kc) {
                    str = 'individuelní člen';
                }
                content = `Čeká se, až ${str} potvrdí hostování.`;
                break;
            case HU.Stav_ZaplaceniPopl:
                content = 'Čeká se na zaplacení správního poplatku za podání hostování.';
                break;
            case HU.Stav_Zpracovani:
                content = 'Čeká se na zpracování hostování sekretariátem ČSTS.';
                break;
            case HU.Stav_Vyrizeno:
                color = "success";
                content = 'Hostování bylo vyřízeno.';
                break;
            case HU.Stav_Ukonceno:
                color = "info";
                content = 'Hostování bylo ukončeno.';
                break;
            case HU.Stav_Zamitnuto:
                color = "danger";
                str = 'individuelním členem i domácím kolektivním členem';
                if (zamitnuto_ic && !zamitnuto_kc) {
                    str = 'individuelním členem';
                } else if (!zamitnuto_ic && zamitnuto_kc) {
                    str = 'domácím kolektivním členem';
                }
                content = `Hostování bylo zamítnuto ${str}.`;
                break;
            case HU.Stav_Stornovan:
                color = "danger";
                content = 'Hostování bylo stornováno.';
                break;
        }

        return <Alert color={color}>{content}</Alert>;
    }
}


export default Stav;